/** Dados de exibição de um participante (avatar sem câmera e nome). */

/** Cores do avatar: todas escuras o bastante para o texto branco passar de 4,5:1. */
const TONES = Object.freeze([
    'bg-violet-700', 'bg-teal-700', 'bg-sky-700', 'bg-emerald-700',
    'bg-orange-700', 'bg-rose-700', 'bg-indigo-700', 'bg-cyan-800',
]);

/** Partículas de nome (Marcos "da" Paz): não valem como sobrenome nas iniciais. */
const NAME_PARTICLES = new Set(['da', 'de', 'do', 'das', 'dos', 'e']);

/**
 * Iniciais: a primeira letra das duas primeiras palavras do nome, ou "?" sem nome. As partículas
 * ("da", "de"...) são puladas, a não ser que sobrasse uma palavra só ("Maria de" continua "MD").
 */
export function initialsOf(name) {
    const words = String(name ?? '').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '?';
    const significant = words.filter((word, index) => index === 0 || !NAME_PARTICLES.has(word.toLowerCase()));
    const pool = significant.length >= 2 ? significant : words;
    return pool.slice(0, 2).map((word) => Array.from(word)[0].toUpperCase()).join('');
}

/** A mesma pessoa tem sempre a mesma cor (depende só da chave, ex.: a identidade no LiveKit). */
export function toneFor(key) {
    const text = String(key ?? '');
    let hash = 0;
    for (let i = 0; i < text.length; i += 1) hash = (hash * 31 + text.charCodeAt(i)) >>> 0;
    return TONES[hash % TONES.length];
}

/** Nome mostrado no tile: o do participante ou o rótulo padrão do papel dele na chamada. */
export function displayNameOf(participant, fallback) {
    const name = typeof participant?.name === 'string' ? participant.name.trim() : '';
    return name || fallback;
}
